import { format, isToday, isTomorrow, parse } from 'date-fns'
import { Box, Heading } from 'ui'

const DATE_FORMAT = 'yyyy-MM-dd'

type GroupHeaderProps = {
  title: string
}

export const GroupHeader = ({ title }: GroupHeaderProps) => {
  const date = parse(title, DATE_FORMAT, new Date())
  const formattedDate = format(date, 'EEE, MMMM d')

  let label = formattedDate
  if (isToday(date)) {
    label = `Today, ${formattedDate}`
  } else if (isTomorrow(date)) {
    label = `Tomorrow, ${formattedDate}`
  }

  return (
    <Box pt={3} pb={2}>
      <Heading level={4} my={0}>
        {label}
      </Heading>
    </Box>
  )
}
